import {JwtHelperService} from "@auth0/angular-jwt";

export class User {
  constructor(public uid: string,
              public username: string,
              public email: string,
              public role: string,
              public refresh_token: string,
              public access_token: string,
              public id_token: string,
              public _tokenExpirationDate: Date,
              public exp: number) {}

  get IdToken() {

    const helper = new JwtHelperService();
    const isExpired = helper.isTokenExpired(this.id_token);
    let current_time = new Date().getTime() / 1000;
    let time_left = this.exp - current_time;


    console.log('from user.model.ts: ','isExpired',isExpired,'time_left: ',time_left);
    if (isExpired) {
      return null;
    }
    if (time_left < 60) {
      return null;
    }
    // if (!this._tokenExpirationDate || new Date() > this._tokenExpirationDate) {
    //   return null;
    // }
    return this.id_token;
  }

  get AccessToken() {
    return this.access_token;
  }

  get RefreshToken() {
    return this.refresh_token;
  }

} // End of class User



